import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=c74bba02&scoped=true"
import script from "./EmailValidation.vue?vue&type=script&lang=js"
export * from "./EmailValidation.vue?vue&type=script&lang=js"
import style0 from "./EmailValidation.vue?vue&type=style&index=0&id=c74bba02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74bba02",
  null
  
)

export default component.exports